import { get_initial_data } from "@/services/get"

export function get_profesional_id(seleccionado, profesional, nombres) {
  let idProfesional
  let indice
  if (seleccionado != null) {
    indice = nombres.findIndex(profesional => profesional.value === seleccionado.value);
    idProfesional = profesional[indice].id
  }
  else {
    idProfesional = 0
  }
  return idProfesional
}

export async function initial_data(server) {
  let newJson = []
  let newJson2 = []
  let insuranseOptions
  let provincias
  let respuesta = {}
  let data = await get_initial_data(server)

  let datosAux = data

  for (let item in datosAux[0]) {
    newJson.push({ value: datosAux[0][item].id, name: datosAux[0][item].name })
  }

  insuranseOptions = newJson
  for (let item in datosAux[1]) {
    newJson2.push({ value: datosAux[1][item].id, name: datosAux[1][item].name })
  }
  provincias = newJson2

  respuesta = { "insuranse": insuranseOptions, "provincias": provincias }
  return respuesta
}

export function traducirState(string) {
  let state = ''
  if (string == "confirmed") {
    state = "Confirmado"
  }
  else if (string == "done") {
    state = "Realizado"
  }
  else if (string == "center_cancelled") {
    state = "Cancelado"
  }
  else if (string == "checked_in") {
    state = "En sala de espera"
  }
  else {
    state = "Cancelado"
  }
  return state;
}

export function convertDateFormat(string) {
  var fecha = string.split(' ')

  var info = fecha[0].split('-').reverse().join('/');
  return info + " " + fecha[1];
}

export function convertirFormatoFecha(date) {
  const fecha = new Date(date);

  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1;
  const anio = fecha.getFullYear();

  const diaFormateado = dia < 10 ? `0${dia}` : dia.toString();
  const mesFormateado = mes < 10 ? `0${mes}` : mes.toString();
  const anioFormateado = anio.toString().slice(-2);

  const fechaFormateada = `${diaFormateado}-${mesFormateado}-${anioFormateado}`;

  return fechaFormateada;
}

export function calcularEdad(dob) {

  const fechaNacimiento = new Date(dob); // fecha de nacimiento
  const today = new Date();

  let edad = today.getFullYear() - fechaNacimiento.getFullYear();
  const mes = today.getMonth() - fechaNacimiento.getMonth();
  const dia = today.getDate() - fechaNacimiento.getDate();

  // Ajuste si aún no cumplió años este año
  if (mes < 0 || (mes === 0 && dia < 0)) {
    edad--;
  }
  return edad
}